import { CarrierSalesDetail } from "../CarrierSalesDetail";
import { CarrierSalesToolPanel } from "../CarrierSalesToolPanel";
import { DataSource, Layout, LayoutHeader, Splitter, Table } from "@mcleod/components";

export abstract class AutogenLayoutCarrierSalesBoard extends Layout {
    layoutCarrierSalesDetail: CarrierSalesDetail;
    layoutCarrierSalesToolPanel: CarrierSalesToolPanel;
    layoutheaderCarrierSalesBoard: LayoutHeader;
    sourceCarrierSales: DataSource;
    sourceCarrierSalesProfile: DataSource;
    splitterSalesBoard: Splitter;
    tableCarrierSalesActions: Table;
}
